// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"15c5f361","403":"4d1e6330","484":"774e8718","551":"f1915462","869":"3a6535e8","974":"0d2103fe"}[chunkId] + ".chunk.js";
};